export default "__VITE_ASSET__Dtm6HqEo__"